import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CheckItem } from '../CheckItem';
import { CORE_PROMISE, withoutSystem, withSystem } from '../../data/salesContent';
export function ComparisonSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" data-id="element-87" data-mp="4zl44y4yhggx">
      <div className="mx-auto max-w-5xl" data-id="element-88" data-mp="9z7duxlksekz">
        <SectionHeading title="Preparar todo desde cero vs. trabajar con un sistema" data-id="element-89" data-mp="9y60gmh37g03" />
        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-90" data-mp="3rewalvobkb8x">
          <div className="rounded-3xl border border-ink-line bg-ink-soft p-7 md:p-9" data-id="element-91" data-mp="19schv3ovw2">
            <h3 className="font-display text-xl font-black uppercase tracking-wide text-neutral-400 md:text-2xl" data-id="element-92" data-mp="34eu0m0sw29">Sin el sistema</h3>
            <ul className="mt-6 space-y-4" data-id="element-93" data-mp="3nduazdqhpx6f">
              {withoutSystem.map(i => <CheckItem key={i} variant="cross" className="text-lg text-neutral-400" data-id="element-94" data-mp="38hd1yt5rwun1">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
          <div className="rounded-3xl border-2 border-gold bg-ink-raised p-7 md:p-9" data-id="element-95" data-mp="z7qxmx5y6ltu">
            <h3 className="font-display text-xl font-black uppercase tracking-wide text-gold md:text-2xl" data-id="element-96" data-mp="z9k68i04fg4h">Con el sistema</h3>
            <ul className="mt-6 space-y-4" data-id="element-97" data-mp="1885k3zune6yx">
              {withSystem.map(i => <CheckItem key={i} className="text-lg font-medium text-cream" data-id="element-98" data-mp="146u2agi0mq1a">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
        </div>
        <p className="mt-14 text-center font-display text-2xl font-black uppercase leading-tight text-gold md:text-4xl" data-id="element-99" data-mp="gevckrhtks4m">{CORE_PROMISE}</p>
      </div>
    </section>;
}